import React from "react";
import "./xod.css";
import {AiTwotoneCalendar} from 'react-icons/ai'
function Xod() {
  return (
    <div className="container my-5">
      <h2 className="text-center my-5">Ход строительства</h2>
      <div className="container">
        <div className="row">
          <div className="col-sm-2 m-3 shadow-custom  p-4">
            Блок A, 1 линия Дата сдачи декабрь 2020
          </div>
          <div className="col-sm-2 m-3 shadow-custom  p-4">
            Блок В, 1 линия Дата сдачи декабрь 2020
          </div>
          <div className="col-sm-2 m-3 shadow-custom  p-4">
            Блок D, 1 линия сдан
          </div>
          <div className="col-sm-2 m-3 shadow-custom  p-4">
            Блок C, 1 линия сдан
          </div>
          <div className="col-sm-2 m-3 shadow-custom  p-4">
            Блок C, 2 линия, д.1 Дата сдачи март 2021
          </div>

          <hr className="divider my-5" />
          <div className="row">
            <div className="col-sm-4 my-3 ">
              <div className="card my-3">
                <img
                  src="https://images.unsplash.com/photo-1501183638710-841dd1904471?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80"
                  className="card-img-top"
                  alt="..."
                />
                <div className="card-body">
                  <p className="card-text">Август 2020</p>
                </div>
              </div>
            </div>
            <div className="col-sm-4">
              <div className="card my-3">
                <img
                  src="https://images.unsplash.com/photo-1599809275695-5e96ca83bc43?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80"
                  className="card-img-top"
                  alt="..."
                />
                <div className="card-body">
                  <p className="card-text"> <AiTwotoneCalendar /> Август 2020</p>
                </div>
              </div>
            </div>
            <div className="col-sm-4">
              <div className="card my-3">
                <img
                  src="https://images.unsplash.com/photo-1484154218962-a197022b5858?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1474&q=80"
                  className="card-img-top"
                  alt="..."
                />
                <div className="card-body">
                  <p className="card-text">Август 2020</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Xod;
